import "./App.scss";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header/Header";
import Main from "./pages/Main/Main";
import Footer from "./components/Footer/Footer";
import Contact from "./components/Contact/Contact";
import BirthdayParties from "./pages/BirthdayParties/BirthdayParties";
import PrivatePlayGroup from "./pages/PrivatePlayGroup/PrivatePlayGroup";
import SpecialEvents from "./pages/SpecialEvents/SpecialEvents";
import MommyandMe from "./pages/MommyandMe/MommyandMe";
import GroupFitness from "./pages/GroupFitness/GroupFitness";
import PersonalTraining from "./pages/PersonalTraining/PersonalTraining";
import Events from "./components/Events/Events";
import WaiverForm from "./components/WaiverForm/WaiverForm";
import WaiverFormKids from "./components/WaiverFormKids/WaiverFormKids";
import StrollerFitness from "./components/StrollerFitness/StrollerFitness";
import Dashboard from "./pages/Dashboard/Dashboard";
import "./Background.css";
// import Alert from "./components/Alert/Alert";

function App() {
  return (
    <Router>
      <div className="App">
        {/* <Alert /> */}
        <Header />

        <div className="background">
          {Array.from({ length: 50 }, (_, i) => (
            <span key={i} />
          ))}
        </div>

        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/birthdayparties" element={<BirthdayParties />} />
          <Route path="/PrivatePlayGroup" element={<PrivatePlayGroup />} />
          <Route path="/specialevents" element={<SpecialEvents />} />
          <Route path="/mommyandme" element={<MommyandMe />} />
          <Route path="/groupfitness" element={<GroupFitness />} />
          <Route path="/personaltraining" element={<PersonalTraining />} />
          <Route path="/strollerfitness" element={<StrollerFitness />} />
          <Route path="/events" element={<Events />} />
          <Route path="/waiver" element={<WaiverForm />} />
          <Route path="/waiverkids" element={<WaiverFormKids />} />

          {/* ✅ Results Dashboard */}
          <Route path="/dashboard" element={<Dashboard />} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
